export default __webpack_public_path__ + "static/bg-form-0099eaf181173226c836b4eaf4742b87.jpg";